import { __rest } from "tslib";
import { DataCapsule } from './data-capsule';
import { CachedStorageStrategy } from './strategies/cached-storage';
import { InMemoryStorageStrategy } from './strategies/in-memory-storage';
import { LocalStorageStrategy, } from './strategies/local-storage';
export function LocalStorageCapsule(options) {
    return new DataCapsule(Object.assign(Object.assign({}, options), { strategy: new LocalStorageStrategy() }));
}
export function InMemoryStorageCapsule(options) {
    return new DataCapsule(Object.assign(Object.assign({}, options), { strategy: new InMemoryStorageStrategy() }));
}
export function LocalStorageCachedCapsule(_a) {
    var { remoteStrategy } = _a, options = __rest(_a, ["remoteStrategy"]);
    return new DataCapsule(Object.assign(Object.assign({}, options), { strategy: new CachedStorageStrategy({
            remoteStrategy,
        }) }));
}
//# sourceMappingURL=capsules.js.map